/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Exercise } from '../entities';
// @ts-ignore
import type { ExerciseBulkCreateRequest } from '../entities';
// @ts-ignore
import type { ExerciseBulkCreateResponse } from '../entities';
// @ts-ignore
import type { ExerciseCreateRequest } from '../entities';
// @ts-ignore
import type { ExerciseSearchRequest } from '../entities';
// @ts-ignore
import type { ExerciseSearchResponse } from '../entities';
/**
 * ExerciseControllerApi - axios parameter creator
 * @export
 */
export const ExerciseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create14: async (exerciseCreateRequest: ExerciseCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseCreateRequest' is not null or undefined
            assertParamExists('create14', 'exerciseCreateRequest', exerciseCreateRequest)
            const localVarPath = `/exercise/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Create15GroupEnum} group 
         * @param {Array<ExerciseBulkCreateRequest>} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create15: async (group: Create15GroupEnum, exerciseBulkCreateRequest: Array<ExerciseBulkCreateRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('create15', 'group', group)
            // verify required parameter 'exerciseBulkCreateRequest' is not null or undefined
            assertParamExists('create15', 'exerciseBulkCreateRequest', exerciseBulkCreateRequest)
            const localVarPath = `/exercise/create/bulk/{group}`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseBulkCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForUser: async (exerciseCreateRequest: ExerciseCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseCreateRequest' is not null or undefined
            assertParamExists('createForUser', 'exerciseCreateRequest', exerciseCreateRequest)
            const localVarPath = `/exercise/createUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSingleExerciseGroupEnum} group 
         * @param {ExerciseBulkCreateRequest} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSingleExercise: async (group: CreateSingleExerciseGroupEnum, exerciseBulkCreateRequest: ExerciseBulkCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('createSingleExercise', 'group', group)
            // verify required parameter 'exerciseBulkCreateRequest' is not null or undefined
            assertParamExists('createSingleExercise', 'exerciseBulkCreateRequest', exerciseBulkCreateRequest)
            const localVarPath = `/exercise/create/single/{group}`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseBulkCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUuids: async (exerciseSearchRequest: ExerciseSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseSearchRequest' is not null or undefined
            assertParamExists('createUuids', 'exerciseSearchRequest', exerciseSearchRequest)
            const localVarPath = `/exercise/create/uuids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete12: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete12', 'id', id)
            const localVarPath = `/exercise/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByUuid2: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteByUuid2', 'uuid', uuid)
            const localVarPath = `/exercise/uuid/{uuid}/delete`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get10: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get10', 'id', id)
            const localVarPath = `/exercise/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByName: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getByName', 'name', name)
            const localVarPath = `/exercise/name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUuid1: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getByUuid1', 'uuid', uuid)
            const localVarPath = `/exercise/uuid/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch6: async (uuid: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('patch6', 'uuid', uuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patch6', 'body', body)
            const localVarPath = `/exercise/uuid/{uuid}/patch`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search10: async (exerciseSearchRequest: ExerciseSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseSearchRequest' is not null or undefined
            assertParamExists('search10', 'exerciseSearchRequest', exerciseSearchRequest)
            const localVarPath = `/exercise/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exerciseSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUrl: async (uuid: string, url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateUrl', 'uuid', uuid)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('updateUrl', 'url', url)
            const localVarPath = `/exercise/{uuid}/update/url`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExerciseControllerApi - functional programming interface
 * @export
 */
export const ExerciseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExerciseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create14(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create14(exerciseCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.create14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Create15GroupEnum} group 
         * @param {Array<ExerciseBulkCreateRequest>} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create15(group: Create15GroupEnum, exerciseBulkCreateRequest: Array<ExerciseBulkCreateRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseBulkCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create15(group, exerciseBulkCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.create15']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForUser(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createForUser(exerciseCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.createForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSingleExerciseGroupEnum} group 
         * @param {ExerciseBulkCreateRequest} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSingleExercise(group: CreateSingleExerciseGroupEnum, exerciseBulkCreateRequest: ExerciseBulkCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseBulkCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSingleExercise(group, exerciseBulkCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.createSingleExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUuids(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUuids(exerciseSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.createUuids']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete12(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete12(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.delete12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByUuid2(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByUuid2(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.deleteByUuid2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get10(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get10(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.get10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByName(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.getByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUuid1(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUuid1(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.getByUuid1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch6(uuid: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch6(uuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.patch6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search10(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search10(exerciseSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.search10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUrl(uuid: string, url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Exercise>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUrl(uuid, url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseControllerApi.updateUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExerciseControllerApi - factory interface
 * @export
 */
export const ExerciseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExerciseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create14(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.create14(exerciseCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Create15GroupEnum} group 
         * @param {Array<ExerciseBulkCreateRequest>} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create15(group: Create15GroupEnum, exerciseBulkCreateRequest: Array<ExerciseBulkCreateRequest>, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseBulkCreateResponse> {
            return localVarFp.create15(group, exerciseBulkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExerciseCreateRequest} exerciseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForUser(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.createForUser(exerciseCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSingleExerciseGroupEnum} group 
         * @param {ExerciseBulkCreateRequest} exerciseBulkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSingleExercise(group: CreateSingleExerciseGroupEnum, exerciseBulkCreateRequest: ExerciseBulkCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseBulkCreateResponse> {
            return localVarFp.createSingleExercise(group, exerciseBulkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUuids(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseSearchResponse> {
            return localVarFp.createUuids(exerciseSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete12(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.delete12(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByUuid2(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.deleteByUuid2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get10(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.get10(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByName(name: string, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.getByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUuid1(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.getByUuid1(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch6(uuid: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.patch6(uuid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExerciseSearchRequest} exerciseSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search10(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseSearchResponse> {
            return localVarFp.search10(exerciseSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUrl(uuid: string, url: string, options?: RawAxiosRequestConfig): AxiosPromise<Exercise> {
            return localVarFp.updateUrl(uuid, url, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExerciseControllerApi - object-oriented interface
 * @export
 * @class ExerciseControllerApi
 * @extends {BaseAPI}
 */
export class ExerciseControllerApi extends BaseAPI {
    /**
     * 
     * @param {ExerciseCreateRequest} exerciseCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public create14(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).create14(exerciseCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Create15GroupEnum} group 
     * @param {Array<ExerciseBulkCreateRequest>} exerciseBulkCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public create15(group: Create15GroupEnum, exerciseBulkCreateRequest: Array<ExerciseBulkCreateRequest>, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).create15(group, exerciseBulkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExerciseCreateRequest} exerciseCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public createForUser(exerciseCreateRequest: ExerciseCreateRequest, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).createForUser(exerciseCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSingleExerciseGroupEnum} group 
     * @param {ExerciseBulkCreateRequest} exerciseBulkCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public createSingleExercise(group: CreateSingleExerciseGroupEnum, exerciseBulkCreateRequest: ExerciseBulkCreateRequest, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).createSingleExercise(group, exerciseBulkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExerciseSearchRequest} exerciseSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public createUuids(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).createUuids(exerciseSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public delete12(id: number, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).delete12(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public deleteByUuid2(uuid: string, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).deleteByUuid2(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public get10(id: number, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).get10(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public getByName(name: string, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).getByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public getByUuid1(uuid: string, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).getByUuid1(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public patch6(uuid: string, body: object, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).patch6(uuid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExerciseSearchRequest} exerciseSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public search10(exerciseSearchRequest: ExerciseSearchRequest, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).search10(exerciseSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {string} url 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseControllerApi
     */
    public updateUrl(uuid: string, url: string, options?: RawAxiosRequestConfig) {
        return ExerciseControllerApiFp(this.configuration).updateUrl(uuid, url, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const Create15GroupEnum = {
    Gluteus: 'GLUTEUS',
    Chest: 'CHEST',
    Back: 'BACK',
    Shoulders: 'SHOULDERS',
    Harmstrings: 'HARMSTRINGS',
    Quadriceps: 'QUADRICEPS',
    Biceps: 'BICEPS',
    Triceps: 'TRICEPS',
    Abs: 'ABS',
    Calves: 'CALVES',
    Traps: 'TRAPS',
    Neck: 'NECK',
    Adductors: 'ADDUCTORS',
    Abductors: 'ABDUCTORS'
} as const;
export type Create15GroupEnum = typeof Create15GroupEnum[keyof typeof Create15GroupEnum];
/**
 * @export
 */
export const CreateSingleExerciseGroupEnum = {
    Gluteus: 'GLUTEUS',
    Chest: 'CHEST',
    Back: 'BACK',
    Shoulders: 'SHOULDERS',
    Harmstrings: 'HARMSTRINGS',
    Quadriceps: 'QUADRICEPS',
    Biceps: 'BICEPS',
    Triceps: 'TRICEPS',
    Abs: 'ABS',
    Calves: 'CALVES',
    Traps: 'TRAPS',
    Neck: 'NECK',
    Adductors: 'ADDUCTORS',
    Abductors: 'ABDUCTORS'
} as const;
export type CreateSingleExerciseGroupEnum = typeof CreateSingleExerciseGroupEnum[keyof typeof CreateSingleExerciseGroupEnum];
